import React from "react";
import { message, Popconfirm } from "antd";

const CustomPopConfirm = ({
  type = "info",
  title = "Are you sure?",
  content,
  onConfirm,
  onCancel,
  showCancel,
  cancelText,
  okText,
  triggerElement,
}) => {
  return (
    <Popconfirm
      title={<span style={{ marginLeft: "8px" }}>{title}</span>}
      description={content}
      onConfirm={onConfirm}
      showCancel={showCancel}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      icon={type === "warning" ? "⚠️" : "ℹ️"}
      
    >
      {triggerElement}
    </Popconfirm>
  );
};

export default CustomPopConfirm;
